import { useCallback } from "react";
import { useAsync } from "@shared/hooks";
import { legacyHttpClient } from "@services/http/legacyHttpClient";

export interface StaticPage {
  id: number;
  slug: string;
  title: string;
  content: string;
}

/**
 * Hook to fetch a static CMS page by slug.
 * GET /rest/api/web/cms/pages/{slug}
 * Used for Términos y Condiciones (slug: "terminos") and
 * Protección de Datos Personales (slug: "privacidad").
 */
export function useStaticPage(slug: string) {
  const fetcher = useCallback(
    () => legacyHttpClient.get<StaticPage>(`/api/web/cms/pages/${slug}`),
    [slug],
  );

  return useAsync<StaticPage>(fetcher);
}
